import { render, staticRenderFns } from "./Config.vue?vue&type=template&id=0a3c26b0&scoped=true&lang=pug&"
import script from "./Config.vue?vue&type=script&lang=js&"
export * from "./Config.vue?vue&type=script&lang=js&"
import style0 from "./Config.vue?vue&type=style&index=0&id=0a3c26b0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a3c26b0",
  null
  
)

export default component.exports